import { OAuthConsentPage } from '../../OAuthConsentPage';
import { PageStoreContainer } from '../../store';

export const ViewCopilotConsent = () => (
  <PageStoreContainer>
    <OAuthConsentPage />
  </PageStoreContainer>
);
